import { useState } from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, CircularProgress, Typography, TextField } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import PageService from '../../services/PageService'

const CreateVersionModal = ({
  projectId,
  createVersionOpen,
  setCreateVersionOpen,
  setTestCasesToggler
}) => {
  const [name, setName] = useState('')
  const [nameError, setNameError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleCloseDialog = () => {
    setCreateVersionOpen(false)
    setName('')
    setNameError('')
  }

  const handleNameChange = (e) => {
    setName(e.target.value)

    if (nameError) {
      setNameError('')
    }
  }

  const handleCreateVersion = async () => {
    if (!projectId) {
      setNameError('Project is required.')
      return
    }

    if (!name.trim()) {
      setNameError('Name is required.')
      return
    } else {
      setNameError('')
    }

    try {
      setLoading(true)
      await PageService.createProjectVersion(projectId, name)
      setTestCasesToggler(prev => !prev)
      setCreateVersionOpen(false)
      setName('')
    } catch (error) {
      if (error?.response?.status === 409) {
        setNameError(error.response.data?.error || 'A version with this name already exists. Please choose a different name.')
      } else {
        console.log(error)
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog open={createVersionOpen} onClose={handleCloseDialog}>
      <Box className="createTestCaseVersionModal">
        <DialogTitle className="createTestCaseVersionModalTitle">
          Create Version
        </DialogTitle>
        <DialogContent className="createTestCaseVersionModalContent">
          <Typography variant='body1' mb={2}>
            Please enter the name of version
          </Typography>
          <TextField
            label="Version Name*"
            type="text"
            fullWidth
            variant="outlined"
            value={name}
            onChange={handleNameChange}
            error={!!nameError}
            helperText={nameError + ' '}
            inputProps={{ maxLength: 50 }}
          />
        </DialogContent>
        <DialogActions className="createTestCaseVersionModalActions">
          <Button className="createTestCaseVersionModalButton" onClick={handleCloseDialog} color="secondary" variant="outlined">
            CANCEL
          </Button>
          {loading ? (
            <LoadingButton
              loading
              className="createTestCaseVersionModalButton"
              variant="contained"
              loadingIndicator={<CircularProgress color="white" size={16} />}
            />
          ) : (
            <Button className="createTestCaseVersionModalButton" onClick={handleCreateVersion} color="secondary" variant="contained" autoFocus>
              SAVE
            </Button>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  )
}

export default CreateVersionModal
